module.exports = __webpack_public_path__ + "assets/img/Currency1.e9aea8a0.png";